<template>
  <div class="page_container Xcontent-box">
    <div class="content-box">
      <EvaluationList />
    </div>
  </div>
</template>

<script>
import EvaluationList from './EvaluationList.vue';

export default {
  components: {
    EvaluationList,
  },
};
</script>

<style></style>
